'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLibsWithDependencies = exports.fetchLibsReqursively = exports.fetchLibrary = exports.searchLibraries = exports.fetchLibData = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _xodFuncTools = require('xod-func-tools');

var _xodProject = require('xod-project');

var _errorCodes = require('./errorCodes');

var ERR_CODES = _interopRequireWildcard(_errorCodes);

var _messages = require('./messages');

var MSG = _interopRequireWildcard(_messages);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// =============================================================================
//
// Utils
//
// =============================================================================

// :: (b -> c) -> (() => Promise a b) -> Promise a c
const retryExceptAny400 = (0, _xodFuncTools.retryOrFail)([500, 1000, 2000, 3000], res => res.status && res.status >= 400 && res.status < 500);

// =============================================================================
//
// Fetching data
//
// =============================================================================

// LibData :: { owner: String, name: String, version: String }

// :: URL -> LibName -> Promise LibData Error
const fetchLibData = exports.fetchLibData = R.curry((swaggerUrl, libQuery) => {
  const fetchFn = (swagger, params) => {
    const tryFn = () => swagger.apis.Library.getOrgLib({
      libname: params.libname,
      orgname: params.owner
    });

    return tryFn().catch(retryExceptAny400((0, _xodFuncTools.rejectFetchResult)({
      message: MSG.cantFindLibrary(params),
      errorCode: ERR_CODES.CANT_FIND_LIB_BY_NAME,
      request: libQuery,
      params
    }), tryFn)).then(R.prop('obj')).then((0, _utils.rejectUnexistingVersion)(params));
  };

  return (0, _utils.getSwaggerClient)(swaggerUrl).then(swagger => R.compose((0, _utils.unfoldMaybeLibQuery)(params => fetchFn(swagger, params)), _utils.parseLibQuery)(libQuery));
});

// :: URL -> String -> Promise LibData Error
const searchLibraries = exports.searchLibraries = R.curry((swaggerUrl, libQuery) => {
  const fetchFn = (swagger, query) => {
    const tryFn = () => swagger.apis.Library.getLibs({
      q: query
    });

    return tryFn().catch(retryExceptAny400((0, _xodFuncTools.rejectFetchResult)({
      message: MSG.cantFindLibrary(query), // TODO: Add another message?
      errorCode: ERR_CODES.CANT_FIND_LIB_BY_NAME,
      request: query
    }), tryFn)).then(R.prop('obj')).then(R.prop('records'));
  };

  return (0, _utils.getSwaggerClient)(swaggerUrl).then(swagger => fetchFn(swagger, libQuery));
});

// :: URL -> LibName -> Promise Project Error
const fetchLibrary = exports.fetchLibrary = R.curry((swaggerUrl, libQuery) => {
  const fetchFn = (swagger, params) => {
    const tryFn = () => swagger.apis.Version.getLibVersionXodball({
      libname: params.libname,
      orgname: params.owner,
      semver_or_latest: params.version
    });

    return tryFn().catch(retryExceptAny400((0, _xodFuncTools.rejectFetchResult)({
      message: MSG.cantFindLibVersion(params),
      errorCode: ERR_CODES.CANT_GET_LIB_XODBALL,
      request: libQuery,
      params
    }), tryFn)).then(R.prop('obj')).then(xodball => R.compose(_xodFuncTools.eitherToPromise, _xodProject.fromXodballData)(xodball).catch((0, _xodFuncTools.rejectWithCode)(ERR_CODES.INVALID_XODBALL)));
  };

  return (0, _utils.getSwaggerClient)(swaggerUrl).then(swagger => R.compose((0, _utils.unfoldMaybeLibQuery)(params => fetchFn(swagger, params)), _utils.parseLibQuery)(libQuery));
});

// :: URL -> [LibName] -> [LibName] -> Map LibName Project -> Promise Map LibName Project Error
const fetchLibsReqursively = exports.fetchLibsReqursively = R.curry((swaggerUrl, existingLibNames, fetchedLibs, libNamesToFetch) => {
  if (libNamesToFetch.length === 0) return Promise.resolve(fetchedLibs);

  const nextLibName = R.head(libNamesToFetch);
  return fetchLibrary(swaggerUrl, nextLibName).then(lib => {
    const nextFetchedLibs = R.assoc(nextLibName, lib, fetchedLibs);
    const fetchedLibNames = R.compose(R.map(_utils.getLibName), R.keys)(nextFetchedLibs);
    const nextLibNamesToFetch = R.compose(R.concat(R.__, R.tail(libNamesToFetch)), R.reject(R.either((0, _xodFuncTools.isAmong)(fetchedLibNames), (0, _xodFuncTools.isAmong)(existingLibNames))), _xodProject.listMissingLibraryNames)(lib);

    return fetchLibsReqursively(swaggerUrl, existingLibNames, nextFetchedLibs, nextLibNamesToFetch);
  });
});

// :: URL -> [LibName] -> [LibName] -> Promise [Project] Error
const fetchLibsWithDependencies = exports.fetchLibsWithDependencies = R.curry((swaggerUrl, existingLibNames, libNamesToFetch) => fetchLibsReqursively(swaggerUrl, existingLibNames, {}, libNamesToFetch));


//////////////////
// WEBPACK FOOTER
// ../xod-pm/dist/fetch.js
// module id = 1263
// module chunks = 0